import type BaseWorker from "./Bases/BaseWorker";
import { WorkerObjectParser } from "./Bases/WorkerObjectParser";
import WorkerPort, { WORKER_PORT_CLEAR_CALLBACKS } from "./Bases/WorkerPort";
import { WorkerAgentPortPolyfill } from "./WorkerPolyfill";

class NodeWorkerMessagePortPolyfill extends EventTarget implements MessagePort {
    public agent!: NodeWorkerPolyfill;

    public onmessage(): void {
        /* no-op */
    }

    public onmessageerror(): void {
        /* no-op */
    }

    public terminate(): void {
        /* no-op */
    }

    public onerror(): void {
        /* no-op */
    }

    public start(): void {
        /* no-op */
    }

    public close(): void {
        /* no-op */
    }

    public postMessage(message: any): void {
        this.agent.onmessage({
            data: message,
        } as any);
    }

    /*
     * Doesn't look like this is used anywhere, if it does need to be used then we need to work out a way
     * to avoid loading the PromotionWorker directly, otherwise it loads the promotion worker into every worker
     * which can lead to the promotion worker stealing the communication ports
    public determineCorrectAgent(worker: BaseWorker): this {
        if(worker instanceof PromotionWorker.constructor) {
            this.agent = workerMap["promotions"];
        } else {
            throw new Error("Unable to resolve correct agent");
        }

        return this;
    }
    */
}

export class NodeWorkerPortPolyfill extends WorkerPort {
    protected agent!: NodeWorkerPolyfill;

    constructor(agent: NodeWorkerPolyfill, worker: BaseWorker) {
        super(new NodeWorkerMessagePortPolyfill(), worker);

        (this.port as NodeWorkerMessagePortPolyfill).agent = agent;

        worker.handleConnection(this.port);
        worker.processConnectionQueue();
    }
}

const workerMap: Record<string, NodeWorkerPolyfill> = {};

export class NodeWorkerPolyfill extends WorkerObjectParser(EventTarget) implements Worker {
    public port: WorkerAgentPortPolyfill;
    protected receiverPort!: NodeWorkerPortPolyfill;
    protected worker!: BaseWorker;

    constructor(url: string | URL, name: string) {
        super();

        if(name === "Shopfront Promotions") {
            import("../Utilities/Domain/Promotions/PromotionWorker")
                .then(module => {
                    this.worker = module.default;
                    this.receiverPort = new NodeWorkerPortPolyfill(this, this.worker);
                });

            workerMap["promotions"] = this;
        } else {
            throw new Error("Unknown worker being polyfilled");
        }

        this.port = new WorkerAgentPortPolyfill(this);
    }

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    public onmessage(_message: MessageEvent): void {
        /* no-op */
    }

    public onmessageerror(): void {
        /* no-op */
    }

    public terminate(): void {
        /* no-op */
    }

    public onerror(): void {
        /* no-op */
    }

    public postMessage(message: any, transfer: Array<Transferable>): void;
    public postMessage(message: any, options?: StructuredSerializeOptions): void;
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    public postMessage(message: any, _transfer?: Array<Transferable> | StructuredSerializeOptions): void {
        if(!this.worker) {
            return;
        }

        const callbacks: Record<string, Function> = {};

        const parsed = this.parseMessage(message, callbacks);

        const complete = (...args: Array<any>): void => {
            if(typeof parsed.success === "function") {
                parsed.success(...args);
            }

            this.sendMessage(WORKER_PORT_CLEAR_CALLBACKS, callbacks);
        };

        this.worker.handleMessage(this.receiverPort, message, complete);
    }

    public sendMessage(event: string, message: any): void {
        this.onmessage({
            data: {
                type : event,
                store: window.location.host.split(".")[0],
                message,
            },
        } as any);
    }
}
